<template>
  <div class="flex min-h-screen flex-col">
    <!-- Header -->
    <div
      class="sticky top-0 z-10 flex h-16 justify-center gap-3 border-b border-b-[--color-primary-a1] bg-additional-50 px-4 lg:h-auto lg:px-12 lg:py-7 print:relative print:px-0 print:shadow-none"
    >
      <div class="flex w-full items-center justify-between md:w-[700px] lg:w-[984px] xl:w-[1300px]">
        <router-link to="/" replace>
          <VcImage
            :src="logoUrl"
            :alt="$context.storeName"
            class="mr-5 h-6 xl:mr-10 print:h-12"
            width="150"
            height="24"
            loading="eager"
            fallback-src="/static/thorlabs/logo.svg"
            lazy
          />
        </router-link>

        <div class="flex">
          <div class="flex items-center gap-x-1.5 print:-mr-px print:border print:px-2">
            <VcIcon :size="16" name="cart" />
            <router-link :to="{ name: 'Cart' }">
              <span class="flex font-medium print:inline">
                {{ $t("common.buttons.return_to_cart") }}
              </span>
            </router-link>
          </div>
          <Created />
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="relative flex grow flex-col">
      <slot />
    </div>

    <VcFooter />
  </div>
</template>

<script setup lang="ts">
import { useDebounceFn } from "@vueuse/core";
import { onMounted } from "vue";
import { useWhiteLabeling } from "@/core/composables";
import { Logger } from "@/core/utilities";
import { useThorlabsGtm } from "@/shared/gtm/gtm";
import VcFooter from "../footer/vc-footer.vue";
import Created from "../print/created.vue";

const { logoUrl } = useWhiteLabeling();
const { gtmSendGenerateLeadEvent } = useThorlabsGtm();

/**
 * This event listeners are attached here to handle clicks on <a> tags with mailto: or tel: links that should trigger generate lead event
 * Some of these links are generated using translation, so these event cannot be directly attached there.
 * The function is debounced to ensure all (or most) elements are rendered before trying to find links.
 */
const attachClickListenersToLeadGeneratingLinksDebounced = useDebounceFn(() => {
  const aElements = document.querySelectorAll("a[data-gtm-lead-source]");

  aElements.forEach((linkElement) => {
    Logger.debug("Attaching link event listener");
    linkElement.addEventListener("click", () => {
      const leadSource = linkElement.getAttribute("data-gtm-lead-source");
      if (leadSource) {
        gtmSendGenerateLeadEvent(leadSource);
      }
    });
  });
}, 1000);

onMounted(() => {
  void attachClickListenersToLeadGeneratingLinksDebounced();
});
</script>
